module.exports = __webpack_public_path__ + "static/media/UDS.bd9a0e88.png";